// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/** Ripples */\n/** Elements */\n/* Palette generated by Material Palette - materialpalette.com/blue/amber */\n/** Ripples */\n/** Elements */\n.mobile-navigation {\n  overflow-x: scroll;\n  overflow-y: hidden;\n  -webkit-box-pack: unset !important;\n      -ms-flex-pack: unset !important;\n          justify-content: unset !important;\n}", ""]);
// Exports
module.exports = exports;
